var _rect, _circle, _path, _circle2, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsPlaceholder2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#11998e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#38ef7d",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    fill: "url(#grad2)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 280,
    r: 80,
    fill: "rgba(255,255,255,0.2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360 280 L380 260 L400 280 L420 250 L460 290 L360 290 Z",
    fill: "rgba(255,255,255,0.4)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 260,
    r: 15,
    fill: "rgba(255,255,255,0.5)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 340,
    width: 200,
    height: 12,
    rx: 6,
    fill: "rgba(255,255,255,0.3)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 360,
    width: 120,
    height: 8,
    rx: 4,
    fill: "rgba(255,255,255,0.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsPlaceholder2);
export default __webpack_public_path__ + "static/media/news-placeholder-2.ff2a34cc5049c81c02c6b9cf6bb7deea.svg";
export { ForwardRef as ReactComponent };